module.exports = __webpack_public_path__ + "static/img/bak03.4aaaf14.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/bak03.jpeg
// module id = Rcmn
// module chunks = 1